"use strict";

var keyMirror = require('keymirror'),
    _ = require('underscore'),
    MobileDetect = require('mobile-detect'),
    config_dev = require('./config_dev'),
    config_prod = require('./config_prod'),
    config_staging = require('./config_staging'),
    roles = keyMirror({
        USER: null,
        ADMIN: null,
        AGENT: null,
        DEVELOPER: null,
        BUILDER: null,
        BROKER: null
    }),
    md = new MobileDetect(window.navigator.userAgent),
    mobile = md.mobile();

var constants = {
    md: md,
    canClipboardCopy: mobile !== 'iPhone' && mobile !== 'iPad',
    root: '/',
    env: window._AS_ENV_,
    server: "production" === "development" ? 'http://dev.agentshield.com' : 'http://app.agentshield.com',
    restPath: "production" === "development" ? '//api.agentshield.com/agent-shield-1.0/rest' : '//api.agentshield.com/agent-shield-1.0/rest',
    trackingPath: ("production" === "development" ? '//dev-api.agentshield.com/t/1x1clear.gif' : '//api.agentshield.com/t/1x1clear.gif') + '?t=' + (new Date()).getTime(),
    roles: roles,
    jsonPSupport: true,
    placeholder: require('../../../../Admin/lib/js/images/placeholder.js'),
    trackerPrefix: 'agent-widgets-',
    mode: window._MODE_ || 'view',
    intercomAppId: 'wfyewo8o',
    intercomAppIdAgent: 'wfyewo8o',
    googleAnalyticsId: 'UA-462934-63',
    thumbRoot: '//s3.amazonaws.com/thumbs.agentshield.com/',
    publicSite: '//newconstructionhub.com'
};

switch (window._AS_ENV_) {
    case 'dev':
        _.extend(constants, config_dev);
        break;
    case 'prod':
        _.extend(constants, config_prod);
        break;
    case 'staging':
        _.extend(constants, config_staging);
        break;
}

constants.imageRoot = constants.imageRoot || (constants.widgetHost + '/resources/images/');

module.exports = constants;
